/*
  Day or night for the public sheet (components/sheet/sheet.css: the landing,
  About, FAQ, the auth flows, not found). It follows the device's colour scheme
  until the reader picks one, and the pick is kept only while it differs from
  the device: picking the mode the device is already in hands the choice back
  to the device.

  Applied to <html data-sheet> before first paint by the boot script in
  index.html, which runs before any module and so duplicates the key and the
  list below; sheet-mode.test.ts fails if they drift. `/y` ignores it: the app
  has its own theme picker (src/lib/themes.ts).
*/

export const SHEET_MODES = ["day", "night"] as const;

export type SheetMode = (typeof SHEET_MODES)[number];

/* Duplicated as a literal in index.html's boot script. */
export const SHEET_STORAGE_KEY = "astring-sheet";

export const NIGHT_QUERY = "(prefers-color-scheme: dark)";

export function isSheetMode(value: unknown): value is SheetMode {
  return typeof value === "string" && (SHEET_MODES as readonly string[]).includes(value);
}

/** The mode to paint: the reader's pick when there is one, otherwise the device's. */
export function resolveSheetMode(stored: unknown, deviceNight: boolean): SheetMode {
  if (isSheetMode(stored)) return stored;
  return deviceNight ? "night" : "day";
}

/** What to keep when the reader picks `mode`: nothing when the device already says it. */
export function keepFor(mode: SheetMode, deviceNight: boolean): SheetMode | null {
  return mode === resolveSheetMode(null, deviceNight) ? null : mode;
}
